import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { ToastMachineService } from './toast-machine.service';
import { BonusLedgerEntry } from '../models/bonus-ledger.model';

@Injectable({
  providedIn: 'root'
})
export class BonusHistoryService {

  constructor(
    private http: HttpClient,
    private toaster: ToastMachineService,
  ) { }

  // bonus_ledger_entries/${profileId}
  async getBonusHistory(profileId: number): Promise<BonusLedgerEntry[]> {
    return new Promise((resolve, reject) => {
      this.http.get(environment.apiURL + '/bonus_ledger_entries/' + profileId).subscribe(
        {
          next: (resp: BonusLedgerEntry[]) => {
            resolve(resp);
          },
          error: err => {
            const error = err.error && err.error.message ? err.error.message : err.error;
            this.toaster.toastMachine(error, 'danger', 3000);
            reject(err);
          }
        });
    });
  }
}
